import { DeleteDialogService } from 'services/delete-dialog-service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ErrorService } from 'services/error-service';
import { ToastService } from 'services/toast-service';
import { PackagingTypeService } from 'services/packaging-type-service';

@autoinject
export class PackagingTypeDetail {
  private packagingtype: Models.PackagingType;

  private constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private packagingTypeService: PackagingTypeService,
    private deleteDialogService: DeleteDialogService
  ) {}

  private activate(params) {
    this.packagingTypeService
      .get(params.Id)
      .then( (res) => {
        this.packagingtype = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private updatePackagingType() {
    this.packagingTypeService
      .put(this.packagingtype, this.packagingtype.Id)
      .then((res) => {
        this.eventAggregator.publish('packagingTypeListReset', 1);
        this.toastService.showSuccess('packagingtype.updated');
        this.router.navigateToRoute('packaging-type-list');
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private deletePackagingType() {
    this.deleteDialogService.confirmBeforeDelete(
      () => {
        this.packagingTypeService
          .delete(this.packagingtype.Id)
          .then((res) => {
            this.eventAggregator.publish('packagingTypeListReset', 1);
            this.toastService.showSuccess('packagingtype.deleted');
            this.router.navigateToRoute('packaging-type-list');
          })
          .catch((err) => this.errorService.handleError(err));
        }
      ); 
  }

  private gotoParentView() {
    this.eventAggregator.publish('packagingTypeListReset', 1);
    this.router.navigateToRoute('packaging-type-list');
  }
}
